import { IconName, spriteUrl } from "assets/sprites/icons-np.generated"
import { createSpriteIconComponent } from "src/components/unstyled/SpriteIcon"

export type NpIconName = IconName

export type NpIconProps = {
  name: NpIconName
  className?: string
}

const RawNpIcon = createSpriteIconComponent<NpIconName>(spriteUrl)

export const NpIcon = ({ name, className }: NpIconProps) => {
  return <RawNpIcon name={name} className={className} />
}
